import React from 'react';
import { WarningOutlined, ClockCircleOutlined } from '@ant-design/icons';
import { toPersianDigits } from '../../../utils/formatPriceToman';

/**
 * کارت شاخص تأخیر ماهانه — مطابق راهنمای استایل تأخیر
 */
const LateSummaryCard = ({ lateTime, lateDaysCount = 0, lateMinutes }) => {
  const time = lateTime != null && lateTime !== '' ? String(lateTime) : '00:00';
  const hasLate =
    (lateMinutes != null && Number(lateMinutes) > 0) ||
    (time !== '00:00' && time !== '0:00' && time !== '۰۰:۰۰');

  return (
    <div
      className={`p-4 rounded-xl border flex items-center justify-between shadow-sm transition-all mb-4 ${
        hasLate
          ? 'bg-amber-50/80 border-amber-200 text-amber-900 dark:bg-amber-950/40 dark:border-amber-800 dark:text-amber-200'
          : 'bg-gray-50 border-gray-200 text-gray-700 dark:bg-slate-800/50 dark:border-slate-700 dark:text-slate-300'
      }`}
      style={{ fontFamily: 'CustomFont' }}
    >
      <div className="flex items-center gap-3">
        <div
          className={`p-2.5 rounded-lg flex items-center justify-center ${
            hasLate ? 'bg-amber-500 text-white' : 'bg-gray-200 text-gray-600 dark:bg-slate-700 dark:text-slate-300'
          }`}
        >
          {hasLate ? <WarningOutlined className="text-lg" /> : <ClockCircleOutlined className="text-lg" />}
        </div>
        <div>
          <p className="text-xs text-gray-500 dark:text-slate-400 font-medium m-0">مجموع تأخیر ماهانه</p>
          <h4 className="text-lg font-bold font-mono tracking-tight m-0 tabular-nums">
            {toPersianDigits(time)}
          </h4>
        </div>
      </div>

      {hasLate && Number(lateDaysCount) > 0 ? (
        <span className="text-xs font-semibold px-2.5 py-1 bg-amber-100 text-amber-800 rounded-full border border-amber-200 dark:bg-amber-900/50 dark:text-amber-200 dark:border-amber-700">
          {toPersianDigits(lateDaysCount)} روز
        </span>
      ) : null}
    </div>
  );
};

export default LateSummaryCard;
